









import Vue from 'vue';

export default Vue.extend({
    props: {
        location: { type: String, required: true },
        value: {
            required: true
        },
        css: { type: String },
        dropdownId: { type: String },
        parentCode: { type: String, required: false },
        placeholder: { type: String, required: false },
        allowUnset: {
            type: Boolean,
            required: false,
            default: false
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        hearingResultList(): Array<{ code: string | null; description: string | null; }> {
            const hearingResultList = this.$typedStore.modules.appealModule.getters.getHearingResultList;

            if (!hearingResultList) {
                return [];
            }

            const resultlist = [];
            for (const itm of hearingResultList) {
                resultlist.push({ code: itm.code, description: itm.description});
            }

            return resultlist;
        },
        disableDropdown(): boolean {
            return this.disabled || this.noOptions;
        },
        noOptions(): boolean {
            return  !this.hearingResultList || !this.hearingResultList.length;
        },
        placeholderText(): string {
            return (this.allowUnset && this.selected !== null) ?
                this.$t('shared.dropdown.unsetLabel').toString() :
                    (this.noOptions ? 'N/A' : (this.placeholder || this.$t('common.select') as string));
        }
    },
    async mounted() {
        if (this.value === undefined) {
            this.selected = null;
        }
        await this.loadHearingResultList();
    },
    data() {
        return {
            selected: this.value as (string | null)
        };
    },
    methods: {
        async loadHearingResultList() {
            await this.$typedStore.modules.appealModule.actions.loadHearingResultList(this.$props.location);
        },
        onChange(e: Event) {
            const sel = (e.target as HTMLSelectElement);
            new Promise((resolve, reject) => {
                if (sel.selectedIndex > 0) {
                    this.$emit('change', sel.options[sel.selectedIndex].text);
                }
                resolve(Response);
            }).then(() => {
                this.$emit('update', sel.options[sel.selectedIndex].value);
            });
        }
    },
    watch: {
        selected(selected: string) {
            this.$emit('input', selected);
        },
        parentCode() {
            this.selected = null;
        },
        value(value: string) {
            this.selected = value?.trim() ?? '';
        }
    }
});
